(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function init(root = document) {
    if (reduced || !('IntersectionObserver' in window)) return;
    root.querySelectorAll('.o-editorial').forEach(el => el.classList.add('o-motion'));
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
    }), { threshold: 0.08 });
    root.querySelectorAll('.o-reveal').forEach(el => observer.observe(el));
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
